import React, { Fragment, useState } from 'react'
import { Link } from 'react-router-dom'
import PersonRounded from '@mui/icons-material/PersonRounded'
import SignUp from '../../users/SignUp'

function LoginLink({slModalOpen}) {

  const [formType, setFormType] = useState('')

  const handleFormType = (type) => {
    setFormType(type)
  }

console.log('formType', formType);
  console.log(slModalOpen)
  return (
    <Fragment>
      <div className="d_d_m_login_link">
        <div className="lgin_link_inr">
          <span>welcome</span>
          <div className="signup_box_dropdown">
            <div className="signup_person_icon concave_neo">
              <PersonRounded />
            </div>
            <div
              className="signUp_btn_drpdwn concave_neo2"
              onClick={() => {
                slModalOpen();
                handleFormType("signup");
              }}
            >
              SIGNUP/LOGIN
            </div>
          </div>
        </div>

        {formType === "signup" && (
          <div className="fixed z-3000 inset-0 bg-black bg-opacity-50 flex justify-center items-center w-[100vw] backdrop-blur-sm">
            <div className="w-fit h-fit p-14 rounded-xl bg-white relative">
              {/* <SignUp /> */}
              SIGNUP FORM
            </div>
          </div>
        )}
        {/* <div className='ex_u_login'>
          <span style={{ fontSize: '0.85rem' }}>Existing user?</span>
          <span style={{fontSize: '0.9rem', fontWeight: '600', cursor: 'pointer'}} onClick={() => {slModalOpen(); handleFormType("signin")}}>LOGIN</span>
        </div> */}
      </div>
    </Fragment>
  );
}

export default LoginLink